import React from 'react';
import cn from 'classnames';

import classes from './radio.module.scss';
import { IOption, IRadio } from './types';

const Radio: React.FC<IRadio> = ({
	className,
	value,
	options,
	onChange,
	renderLabel,
	isAllSubOptionsVisible,
}) => {
	const handleClick =
		(option: IOption) =>
		(e: React.MouseEvent<HTMLDivElement>): void => {
			if (option.disabled) {
				return;
			}
			e.stopPropagation();
			onChange(option.value, option);
		};

	const renderOption = (option: IOption) => {
		const isSelected =
			option.value === value ||
			option.subOptions?.find((subOption) => subOption.value === value);
		const isSubOptionsVisible =
			option.subOptions &&
			option.subOptions.length > 0 &&
			(isSelected || isAllSubOptionsVisible);
		return (
			<div
				className={cn(classes.option, option.className, {
					[classes.option__selected]: isSelected,
					[classes.option__notSelected]: !isSelected,
					[classes.option__disabled]: option.disabled,
				})}
				key={option.value + option.label}
				onClick={handleClick(option)}
			>
				<div className={classes.box} />
				{renderLabel ? (
					renderLabel(option)
				) : (
					<div className={classes.info}>
						<div className={classes.label}>
							{option.label}
							{option.disabled && option.disabledText && (
								<span className={classes.disabledText}>
									{option.disabledText}
								</span>
							)}
						</div>
						{option.description && (
							<div className={classes.description}>
								{option.description}
							</div>
						)}
						{isSubOptionsVisible && (
							<div className={classes.subOptions}>
								{option.subOptions?.map(renderOption)}
							</div>
						)}
					</div>
				)}
			</div>
		);
	};

	return (
		<div className={cn(classes.radio, className)}>
			{options.map(renderOption)}
		</div>
	);
};

export default Radio;
